import { useSearchParams } from "react-router-dom";
import {
	ClipboardCheck,
	Clock,
	Store,
	TrendingUp,
	CalendarDays
} from "lucide-react";
import { PublishedForms } from "src/containers";
import { FormCategoriesList } from "src/features/observations/containers/FormCategoriesList";
import { usePublishedFormsCategories } from "src/hooks/usePublishedFormsCategories";
import useReportsSummary from "src/features/reporting/hooks/useReportsSummary/useReportsSummary";

const Forms = () => {
	const [searchParams] = useSearchParams();
	const { data: categories, isLoading: isCategoriesLoading } =
		usePublishedFormsCategories();
	const { data: summary } = useReportsSummary({ enabled: false });

	const category = searchParams.get("category") || "";

	const stats = summary
		? [
				{
					label: "Completed (7 days)",
					value: summary.completedLast7Days,
					icon: CalendarDays,
					color: "text-primary"
				},
				{
					label: "Completed (30 days)",
					value: summary.completedLast30Days,
					icon: ClipboardCheck,
					color: "text-emerald-500"
				},
				{
					label: "In Progress",
					value: summary.inProgress,
					icon: Clock,
					color: "text-amber-500"
				},
				{
					label: "Compliance Rate",
					value: `${summary.compliantRate}%`,
					icon: TrendingUp,
					color: "text-violet-500"
				},
				{
					label: "Active Stores",
					value: summary.activeStores,
					icon: Store,
					color: "text-zinc-600"
				}
			]
		: null;

	return (
		<div aria-label="All published forms">
			{category && (
				<PublishedForms
					formsRedirectBaseUrl="/observations/submissions/"
					category={category}
				/>
			)}

			{!category && (
				<div>
					{stats && (
						<div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
							{stats.map((stat) => (
								<div
									key={stat.label}
									className="rounded-xl border border-border bg-white p-5 shadow-sm"
								>
									<div className="flex items-center gap-3 mb-2">
										<stat.icon className={`h-5 w-5 ${stat.color}`} />
										<span className="text-sm text-muted-foreground">
											{stat.label}
										</span>
									</div>
									<p className="font-heading text-2xl font-semibold text-foreground">
										{stat.value}
									</p>
								</div>
							))}
						</div>
					)}

					<h2 className="font-heading text-lg font-medium text-foreground mb-6">
						Categories
					</h2>

					{isCategoriesLoading ? (
						<div className="flex justify-center py-12">
							<div className="w-5 h-5 border-2 border-border border-t-primary rounded-full animate-spin" />
						</div>
					) : (
						<FormCategoriesList
							categories={categories}
							admin={false}
							itemHref={(category) =>
								`/observations/submissions/?category=${category.name}`
							}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default Forms;
